import { render, staticRenderFns } from "./SuggestionSelect.vue?vue&type=template&id=f9c0748c&"
import script from "./SuggestionSelect.vue?vue&type=script&lang=js&"
export * from "./SuggestionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports